<div class="wrapper">
    <mat-card appearance="outlined">
        <mat-card-header class="text-uppercase tal">
            <mat-card-title>{{'certificateDetails' | translate}}
                <span class="close">
                    <button class="close-btn" (click)="closeDialog()">
                        <cqes-icon icon="close"></cqes-icon>
                    </button>
                </span>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content class="container">
            <div class="row">
                <div class="col-12">
                    <div class="container">
                        <ng-template [ngIf]="wait" [ngIfElse]="certificateDetails">
                            <div class="row">
                                <div class="col-4 col-centered">
                                    <mat-spinner></mat-spinner>
                                </div>
                            </div>
                        </ng-template>
                        <ng-template #certificateDetails>
                            <div class="row">
                                <div class="col-12">
                                    <div class="cert-details-section">

                                        <!--Personal number-->
                                        <div class="row">
                                            <div class="col-12 label col-md-4">
                                                {{personalIdLabel(certificate.personalId) | translate}}</div>
                                            <div class="col-12 col-md-8">{{personalIdValue(certificate.personalId)}}</div>
                                        </div>

                                        <!-- Owner-->
                                        <div class="row">
                                            <div class="col-12 label col-md-4">{{'manageTexts.owner' | translate}}</div>
                                            <div class="col-12 col-md-8" *ngIf="certificate.owner">{{certificate.owner[lang]}}
                                            </div>
                                        </div>

                                        <!-- Email-->
                                        <div class="row">
                                            <div class="col-12 label col-md-4">{{'manageTexts.email' | translate}}</div>
                                            <div class="col-12 col-md-8" *ngIf="certificate.owner">{{certificate.email}}</div>
                                        </div>

                                        <!-- issued date-->
                                        <div class="row">
                                            <div class="col-12 label col-md-4">{{'manageTexts.issuedOn' | translate}}</div>
                                            <div class="col-12 col-md-8">{{certificate.issuedOn | date: dateFormat}}</div>
                                        </div>

                                        <!-- valid from-->
                                        <div class="row">
                                            <div class="col-12 label col-md-4">{{'manageTexts.validFrom' | translate}}</div>
                                            <div class="col-12 col-md-8">{{certificate.validFrom | date: dateFormat}}</div>
                                        </div>

                                        <!-- valid to-->
                                        <div class="row">
                                            <div class="col-12 label col-md-4">{{'manageTexts.validTo' | translate}}</div>
                                            <div class="col-12 col-md-8">{{certificate.validTo | date: dateFormat}}</div>
                                        </div>

                                        <!-- serialNo-->
                                        <div class="row">
                                            <div class="col-12 label col-md-4">{{'manageTexts.serial' | translate}}</div>
                                            <div class="col-12 col-md-8">{{certificate.serialNo}}</div>
                                        </div>

                                        <!-- serial hex-->
                                        <div class="row">
                                            <div class="col-12 label col-md-4">{{'manageTexts.serialHEX' | translate}}</div>
                                            <div class="col-12 col-md-8">{{certificate.serialNumber}}</div>
                                        </div>

                                        <!-- status -->
                                        <div class="row">
                                            <div class="col-12 label col-md-4">{{'manageTexts.status' | translate}}</div>
                                            <div class="col-12 col-md-8">{{statusName(certificate.status) | translate}}</div>
                                        </div>
                                    </div>

                                    <div class="divide-container">
                                        <mat-divider></mat-divider>
                                    </div>

                                    <div class="cert-details-section">
                                        <!--Plan type-->
                                        <div class="row">
                                            <div class="col-12 label col-md-4">{{'manageTexts.planName' | translate}}</div>
                                            <div class="col-12 col-md-8" *ngIf="certificate.packType">
                                                {{planName(certificate.packType) | translate}}</div>
                                        </div>

                                        <!-- Remaining count-->
                                        <div class="row">
                                            <div class="col-12 label col-md-4">{{'manageTexts.remainingCount' | translate}}</div>
                                            <div class="col-12 col-md-8">
                                                <ng-template [ngIf]="isInfinite(certificate)"
                                                    [ngIfElse]="remainingCount">
                                                    <div class="infinite-font">
                                                        {{'manageTexts.infiniteCount' | translate}}
                                                    </div>
                                                </ng-template>
                                                <ng-template #remainingCount>
                                                    <div> {{certificate.remainingCount}}</div>
                                                </ng-template>
                                            </div>
                                        </div>

                                        <!-- Alias -->
                                        <div class="row">
                                            <div class="col-12">
                                                <div class="row">
                                                    <div class="col-12 label col-md-4"><label
                                                            for="alias">{{'manageTexts.alias' | translate}}</label>
                                                    </div>
                                                    <div class="col-md-6 col-12">
                                                        <mat-form-field>
                                                            <input matInput [(ngModel)]="certificate.alias" name="alias" id="alias"
                                                                #aliasControl="ngModel" [pattern]="aliasPattern" maxlength="50" [errorStateMatcher]="matcher">
                                                            <mat-hint>{{'manageTexts.hints.maxLengthAlias' | translate}}
                                                            </mat-hint>
                                                            <mat-error *ngIf="aliasControl.invalid">
                                                                    {{'manageTexts.invalidAlias' | translate}}
                                                            </mat-error>
                                                        </mat-form-field>
                                                    </div>
                                                </div>

                                                <div class="divide-container">
                                                    <mat-divider></mat-divider>
                                                </div>

                                                <div class="row" id="save-btn-row">
                                                    <div class="col-12">
                                                        <div class="btn-wrapper">
                                                            <button class="mat-mdc-raised-button accent action-button"
                                                                (click)="closeDialog()">{{'manageTexts.detailsClose' | translate}}
                                                            </button>
                                                            <button class="mat-mdc-raised-button action-button"
                                                                (click)="onSaveAlias()" [disabled]="aliasControl.invalid">{{'manageTexts.detailsSave' | translate}}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </div>
        </mat-card-content>
    </mat-card>
</div>
